import React, { useCallback, useEffect } from "react";
import Page from "./Page";
import { useDispatch, useSelector } from "react-redux";
import LoadingModal from "../components/shared/modals/LoadingModal";
import PassengerHistoryItem from "../components/passengers/PassengerHistoryItem";
import { Box, Grid, Typography } from "@mui/material";
import { routeActions } from "../store/slices/routeSlice";

const SchedulingHistory = () => {
  const { cancelledRoutesLoading, cancelledRoutes, cancelledRoutesError } =
    useSelector((state) => state.route);
  const dispatch = useDispatch();

  const fetchCancelledRoutes = useCallback(() => {
    dispatch(routeActions.getCancelledRoutesFetch());
  }, [dispatch]);

  useEffect(() => {
    fetchCancelledRoutes();
  }, [fetchCancelledRoutes]);

  if (cancelledRoutesLoading) return <LoadingModal />;

  if (cancelledRoutesError)
    return (
      <Page>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "inherit !important",
            marginTop: "1rem",
            flexDirection: "column",
          }}
        >
          <Typography color="error" sx={{ fontSize: "1.25rem" }}>
            Došlo je do greške
          </Typography>
          <Typography
            sx={{
              fontSize: "1rem",
              marginTop: "0.5rem",
              fontStyle: "italic",
              cursor: "pointer",
            }}
            onClick={fetchCancelledRoutes}
          >
            Pokušajte ponovo
          </Typography>
        </Box>
      </Page>
    );

  return (
    <Page>
      <Grid container spacing={2} className="mt-2">
        {cancelledRoutes &&
          cancelledRoutes.length > 0 &&
          cancelledRoutes.map((route, index) => (
            <Grid item xs={12} sm={12} md={6} lg={3} key={index}>
              <PassengerHistoryItem
              id={route.id}
              departure={route.departure}
              fullName={route.fullName}
              arrival={route.arrival}
              mainContact={route.phoneNumber}
              />
            </Grid>
          ))}
      </Grid>
    </Page>
  );
};

export default SchedulingHistory;
